<div class="pricing-container" fxHide.lt-md>
  <div class="plans-header">
    <div class="plan-column"></div> 
    <div class="plan-column">
      <div class="plan-title">{{item.customField16}}</div>
      <button class="try-now" [style.color]="item.customField23" [style.border]="'1px solid ' + item.customField23">{{item.customField21}}</button>
    </div>
    <div class="plan-column">
      <div class="plan-title">{{item.customField17}}</div>
      <button class="try-now" [style.color]="item.customField23" [style.border]="'1px solid ' + item.customField23">{{item.customField21}}</button>
    </div>
    <div class="plan-column">
      <div class="plan-title">{{item.customField18}}</div>
      <button class="try-now" [style.color]="item.customField23" [style.border]="'1px solid ' + item.customField23">{{item.customField21}}</button>
    </div>
    <div class="plan-column">
      <div class="plan-title">{{item.customField19}}</div>
      <button class="try-now" [style.color]="item.customField23" [style.border]="'1px solid ' + item.customField23">{{item.customField21}}</button>
    </div>
    <div class="plan-column">
      <div class="plan-title">{{item.customField24}}</div>
      <button class="try-now" [style.color]="item.customField23" [style.border]="'1px solid ' + item.customField23">{{item.customField21}}</button>
    </div>
  </div>
  <div class="sectionz">
    <div >Pricing</div>    
  </div>

  <div class="pricing-section">
    <div class="row-label">Billed Annually</div>
    <div class="pricing-cell">{{pricedetail.free_charge_year}}</div>
    <div class="pricing-cell">{{pricedetail.std_charge_year}}</div>
    <div class="pricing-cell">{{pricedetail.pro_charge_year}}</div>
    <div class="pricing-cell">{{pricedetail.ent_charge_year}}</div>
    <div class="pricing-cell">{{pricedetail.u_charge_year}}</div>
  </div>

  <div class="pricing-section">
    <div class="row-label">Billed Monthly</div>
    <div class="pricing-cell">{{pricedetail.free_charge_month}}</div>
    <div class="pricing-cell">{{pricedetail.std_charge_month}}</div>
    <div class="pricing-cell">{{pricedetail.pro_charge_month}}</div>
    <div class="pricing-cell">{{pricedetail.ent_charge_month}}</div>
    <div class="pricing-cell">{{pricedetail.u_charge_month}}</div>
  </div>

<div class="accordion-container">
  <div *ngFor="let section of price_detail; let i = index">
    
    <!-- Accordion Header -->
    <div class="accordion-header" (click)="toggleSection(i)">
      <div class="header-title">{{ section.title }}</div>
      <mat-icon>{{ section.open ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
    </div>

    <!-- Accordion Body -->
    <div *ngIf="section.open" class="accordion-body">

      <!-- Feature Rows -->
      <div *ngFor="let item of section.list_detail" class="feature-row">

        <!-- Column 1: Feature Name -->
        <div class="pricing-cell feature-name" >
          <b>{{ item.sub_title }}</b>
        </div>

        <!-- Column 2: Free -->
        <div class="pricing-cell" fxLayoutAlign="center center">
          <ng-container [ngSwitch]="item.id_element">
            <mat-icon *ngSwitchCase="'done'" class="check-icon">done</mat-icon>
            <mat-icon *ngSwitchCase="'none'" class="check-icon2">minimize</mat-icon>
            <span *ngSwitchDefault>{{ item.id_element }}</span>
          </ng-container>
        </div>

        <!-- Column 3: Standard -->
        <div class="pricing-cell" fxLayoutAlign="center center">
          <ng-container [ngSwitch]="item.starter">
            <mat-icon *ngSwitchCase="'done'" class="check-icon">done</mat-icon>
            <mat-icon *ngSwitchCase="'none'" class="check-icon2">minimize</mat-icon>            
            <span *ngSwitchDefault>{{ item.starter }}</span>
          </ng-container>
        </div>

        <!-- Column 4: Professional -->
        <div class="pricing-cell" fxLayoutAlign="center center">
          <ng-container [ngSwitch]="item.profession">
            <mat-icon *ngSwitchCase="'done'" class="check-icon">done</mat-icon>
            <mat-icon *ngSwitchCase="'none'" class="check-icon2">minimize</mat-icon>            
            <span *ngSwitchDefault>{{ item.profession }}</span>
          </ng-container>
        </div>

        <!-- Column 5: Enterprise -->
        <div class="pricing-cell" fxLayoutAlign="center center">
          <ng-container [ngSwitch]="item.advanced">
            <mat-icon *ngSwitchCase="'done'" class="check-icon">done</mat-icon>
            <mat-icon *ngSwitchCase="'none'" class="check-icon2">minimize</mat-icon>            
            <span *ngSwitchDefault>{{ item.advanced }}</span>
          </ng-container>
        </div>

        <!-- Column 6: Ultimate -->
        <div class="pricing-cell" fxLayoutAlign="center center">
          <ng-container [ngSwitch]="item.table_color">
            <mat-icon *ngSwitchCase="'done'" class="check-icon">done</mat-icon>
            <mat-icon *ngSwitchCase="'none'" class="check-icon2">minimize</mat-icon>            
            <span *ngSwitchDefault>{{ item.table_color }}</span>
          </ng-container>
        </div>

      </div>
    </div>
  </div>
</div>

</div>


<div fxHide fxShow.lt-md>

<div class="price-table-wrapper">
  <div class="price-table-scrollable">

    <!-- Plan Header Row -->
    <div class="price-row price-plan-header">
      <div class="price-cell plan-column"></div>
      <div class="price-cell plan-column" *ngFor="let title of [item.customField16, item.customField17, item.customField18, item.customField19, item.customField24]">
        <div class="plan-title-text">{{ title }}</div>
        <button class="plan-try-now" [style.color]="item.customField23" [style.border]="'1px solid ' + item.customField23">
          {{ item.customField21 }}
        </button>
      </div>
    </div>
    <div class="sectionx">
        <div >Pricing</div>    
    </div>
    
    <div class="price-row">
      <div class="price-cell row-label-cell" fxLayoutAlign="center center">Billed Annually</div>
      <div class="price-cell" fxLayoutAlign="center center">{{ pricedetail.free_charge_year }}</div>
      <div class="price-cell" fxLayoutAlign="center center">{{ pricedetail.std_charge_year }}</div>
      <div class="price-cell" fxLayoutAlign="center center">{{ pricedetail.pro_charge_year }}</div>
      <div class="price-cell" fxLayoutAlign="center center">{{ pricedetail.ent_charge_year }}</div>
      <div class="price-cell" fxLayoutAlign="center center">{{ pricedetail.u_charge_year }}</div>
    </div>

    <div class="price-row">
      <div class="price-cell row-label-cell" fxLayoutAlign="center center">Billed Monthly</div>
      <div class="price-cell" fxLayoutAlign="center center">{{ pricedetail.free_charge_month }}</div>
      <div class="price-cell" fxLayoutAlign="center center">{{ pricedetail.std_charge_month }}</div>
      <div class="price-cell" fxLayoutAlign="center center">{{ pricedetail.pro_charge_month }}</div>
      <div class="price-cell" fxLayoutAlign="center center">{{ pricedetail.ent_charge_month }}</div>
      <div class="price-cell" fxLayoutAlign="center center">{{ pricedetail.u_charge_month }}</div>
    </div>

    <!-- Features Accordion -->
    <div *ngFor="let section of price_detail; let i = index">
        <div class="feature-section-header" (click)="toggleSection(i)">
        <div class="header-icon-circle">
            <mat-icon style="  margin-left: -2px;">{{ section.open ? 'remove' : 'add' }}</mat-icon>
        </div>
        <span class="header-title-text">{{ section.title }}</span>
        </div>


      <div *ngIf="section.open">
        <div *ngFor="let item of section.list_detail" class="price-row">
          <div class="price-cell row-label-cell" >{{ item.sub_title }}</div>

          <div class="price-cell" fxLayoutAlign="center center">
            <ng-container [ngSwitch]="item.id_element">
              <mat-icon *ngSwitchCase="'done'" class="feature-check-icon">done</mat-icon>
              <mat-icon *ngSwitchCase="'none'" class="check-icon2">minimize</mat-icon>            
              <span *ngSwitchDefault>{{ item.id_element }}</span>
            </ng-container>
          </div>

          <div class="price-cell" fxLayoutAlign="center center">
            <ng-container [ngSwitch]="item.starter">
              <mat-icon *ngSwitchCase="'done'" class="feature-check-icon">done</mat-icon>
                          <mat-icon *ngSwitchCase="'none'" class="check-icon2">minimize</mat-icon>            
              <span *ngSwitchDefault>{{ item.starter }}</span>
            </ng-container>
          </div>

          <div class="price-cell" fxLayoutAlign="center center">
            <ng-container [ngSwitch]="item.profession">
              <mat-icon *ngSwitchCase="'done'" class="feature-check-icon">done</mat-icon>
                          <mat-icon *ngSwitchCase="'none'" class="check-icon2">minimize</mat-icon>            
              <span *ngSwitchDefault>{{ item.profession }}</span>
            </ng-container>
          </div>

          <div class="price-cell" fxLayoutAlign="center center">
            <ng-container [ngSwitch]="item.advanced">
              <mat-icon *ngSwitchCase="'done'" class="feature-check-icon">done</mat-icon>
                          <mat-icon *ngSwitchCase="'none'" class="check-icon2">minimize</mat-icon>            
              <span *ngSwitchDefault>{{ item.advanced }}</span>
            </ng-container>
          </div>

          <div class="price-cell" fxLayoutAlign="center center">
            <ng-container [ngSwitch]="item.table_color">
              <mat-icon *ngSwitchCase="'done'" class="feature-check-icon">done</mat-icon>
                          <mat-icon *ngSwitchCase="'none'" class="check-icon2">minimize</mat-icon>            
              <span *ngSwitchDefault>{{ item.table_color }}</span>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>

</div>
